import {Pipe, PipeTransform} from '@angular/core';
import {loadMediaUrl} from '../utils/media-url-loader';

@Pipe({
  name: 'mediaUrl',
  standalone: true
})
export class MediaUrlPipe implements PipeTransform {
  public transform(path: string | null | undefined, width?: number): string | null {
    if (!path) {
      return null;
    }

    return loadMediaUrl({src: path, width});
  }
}
